/* eslint-disable */
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'author-details-create',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      submitted: false,
      courseDetails: '',
      name: '',
      gender: '',
      organization: '',
      location: '',
      course:'',
      courseId:'',
      AuthorListDetails:'',
      removeAuthorId:'',
      credential:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
    }
  },
  computed: {
    ...mapGetters([
      'getAuthorDataState',
    ]),
    geAuthorListByIdFun() {
      this.$store.dispatch('getAuhtorsFun', {
        id: this.$route.params.courseId
      }).then((res) => {
        this.AuthorListDetails = this.$store.getters.getAuthorDataState.data
        console.log(this.AuthorListDetails, 'Author Details List')
      }).catch((err) => {})
    },
  },
  mounted() {
    this.geAuthorListByIdFun
    this.courseId = this.$route.params.courseId
  },
  methods: {
    geAuthorListByIdFunAgain() {
      this.$store.dispatch('getAuhtorsFun', {
        id: this.$route.params.courseId
      }).then((res) => {
        this.AuthorListDetails = this.$store.getters.getAuthorDataState.data
      }).catch((err) => {})
    },
   createAuthorNamConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
              name: this.name,
              gender: this.gender,
              organization: this.organization,
              location: this.location,
              credential: this.credential,
              course:this.$route.params.courseId
          }
          this.$store.dispatch('createAuhtorFun', data)
            .then((res) => {
              this.name = '',
                this.gender = '',
                this.organization = '',
                this.location = '',
                this.credential = '',
              toast.success(res.data.msg);
              this.$validator.reset();
              this.geAuthorListByIdFunAgain()
            })
            .catch((err) => { })
          return
        }
      });
    },
    removeAuthor(id) {
      $('#removAuthorModalAgain').modal();
      this.removeAuthorId = id
    },
    RemoveAuthorConfirmationagain(){
      this.$store.dispatch('removAuthorFun', {
        id: this.removeAuthorId
      }).then((res) => {
        this.geAuthorListByIdFunAgain()
      }).catch((err) => {})
    }
  }
}